module.exports = __webpack_public_path__ + "static/media/cq_freccia_destra.6729583c.svg";